import { Component, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Ubicacion } from 'src/app/models/Ubicacion';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { OrderPrestadorService } from 'src/app/services/order-prestador.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
    selector: 'app-seleccion-ubicacion-prestador',
    templateUrl: './seleccion-ubicacion-prestador.component.html',
    styleUrls: ['./seleccion-ubicacion-prestador.component.css'],
    standalone: false
})
export class SeleccionUbicacionPrestadorComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _location = inject(Location);
  private readonly _authService = inject(AuthService);
  private readonly _usuarioService = inject(UsuarioService);
  private readonly _orderPrestadorService = inject(OrderPrestadorService);
  private readonly _loadingService = inject(LoadingService);

  error = signal<string>('');
  helpOpen = signal<boolean>(false);
  helpText = signal<string>('Este profesional atiende en más de un lugar. Elegí dónde preferís el turno.');

  ubicaciones = signal<Ubicacion[]>([]);
  idUbicacionSeleccionada = signal<number>(0);

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();

        const ord = this._orderPrestadorService.ordenPrestador;

        if (!ord.id_prestador) {
          this._router.navigate(['/dashboard']);
          return;
        }

        let ubicaciones = this._orderPrestadorService.ubicacionesPrestador;
        if (!ubicaciones || ubicaciones.length === 0) {
          ubicaciones = await firstValueFrom(
            this._usuarioService.getUbicaciones(ord.id_prestador, true)
          );
          this._orderPrestadorService.ubicacionesPrestador = ubicaciones ?? [];
        }

        if (!ubicaciones || ubicaciones.length === 0) {
          this._router.navigate(['/fecha-turno']);
          return;
        }

        // Si ya no hace falta elegir (por ej. se llegó directo a esta pantalla), completar solo.
        if (ubicaciones.length === 1) {
          ord.id_ubicacion = ubicaciones[0].id ?? null;
          this._orderPrestadorService.ubicacionSeleccionada = ubicaciones[0];
          this._router.navigate(['/resumen-order-prestador']);
          return;
        }

        this.ubicaciones.set(ubicaciones);

        const actual = ubicaciones.find(u => u.id === ord.id_ubicacion);
        this.idUbicacionSeleccionada.set(actual?.id ?? ubicaciones[0].id ?? 0);
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudieron obtener los lugares de atención del profesional.');
      }
    });
  }

  continuar(): void {
    this.error.set('');

    const id = this.idUbicacionSeleccionada();
    const ubicacion = this.ubicaciones().find(u => u.id === id);

    if (!ubicacion) {
      this.error.set('Debe seleccionar un lugar.');
      return;
    }

    this._orderPrestadorService.ordenPrestador.id_ubicacion = ubicacion.id ?? null;
    this._orderPrestadorService.ubicacionSeleccionada = ubicacion;

    this._router.navigate(['/resumen-order-prestador']);
  }

  openhelp(): void {
    this.helpOpen.update(v => !v);
  }

  back(): void {
    this._location.back();
  }

  trackByUbiId = (_: number, u: Ubicacion) => u.id ?? _;
}
